import { render, staticRenderFns } from "./CarrierDestinationFormModal.vue?vue&type=template&id=b7eddc64&scoped=true&"
import script from "./CarrierDestinationFormModal.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eddc64",
  null
  
)

export default component.exports